"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../theme");
var useStyles = (0, _theme.makeStyles)(function () {
  return {
    headerContainer: {
      height: '141px',
      paddingTop: '24px',
      borderBottom: '1px solid #7070701A'
    },
    close: {
      "float": 'right',
      display: 'inline-block',
      marginTop: '-24px',
      height: '10px',
      width: '10px',
      marginRight: '27px'
    },
    paper: {
      backgroundColor: 'white',
      width: '589px',
      margin: 'auto',
      verticalAlign: 'middle',
      borderRadius: '10px',
      boxShadow: '0 3px 6px #00000029'
    },
    title: {
      fontSize: '18px',
      textAlign: 'center',
      fontWeight: 400,
      marginBottom: '33px'
    },
    progress: {
      width: 'calc(100%-120px)',
      marginLeft: '60px',
      marginRight: '60px'
    }
  };
}, {
  name: 'StepsModal'
});
exports.useStyles = useStyles;